<template>
	<div class="card">
		<div class="card-header">
			<span class="fs-5">Data Presensi</span>
		</div>
		<div class="card-body p-0" v-loading="loading">
			<el-tabs v-model="activeTab" type="border-card" @tab-change="handleTabChange" class="rounded-bottom border-0">
				<el-tab-pane label="Guru" name="presensi-guru" />
				<el-tab-pane label="Tenaga Kependidikan" name="presensi-karyawan" />
				<el-tab-pane label="Siswa" name="presensi-siswa" />
				<el-tab-pane label="Non-GTK" name="presensi-non-gtk" />
				<el-tab-pane label="Rekapitulasi" name="presensi-rekap" />
				<router-view :list-mesin="listMesin" :is-petugas-presensi="isPetugasPresensi" v-slot="{ Component }">
					<transition name="fade" mode="out-in">
						<div v-if="routeName === 'presensi'" class="row g-3">
							<div class="text-center" v-if="loading">Memuat...</div>
							<div class="text-center" v-else-if="riwayatPresensi.length === 0">Data tidak ditemukan</div>
							<div v-for="rp in riwayatPresensi" :key="rp.type" class="col-12 col-sm-6 col-md-4 col-lg-3" v-else>
								<div class="card">
									<div class="card-header small">
										{{ userTypes[rp.type]?.label || "lainnya" }}
										<router-link :to="{ name: userTypes[rp.type]?.name || 'presensi' }">
											<el-icon><i class="bi bi-box-arrow-in-up-right"></i></el-icon>
										</router-link>
									</div>
									<div class="card-body">
										<div class="d-flex gap-1 align-items-baseline">
											<transition name="slide-up" mode="out-in">
												<span class="fs-5" :key="rp.jumlah">
													{{ rp.jumlah }}
												</span>
											</transition>
											riwayat
										</div>
									</div>
								</div>
							</div>
						</div>
						<component :is="Component" v-else />
					</transition>
				</router-view>
			</el-tabs>
		</div>
	</div>
</template>

<script>
export default {
	name: "PresensiView",
	data() {
		return {
			riwayatPresensi: [],
			userTypes: {
				guru: { label: "Guru", name: "presensi-guru" },
				karyawan: { label: "Tenaga Kependidikan", name: "presensi-karyawan" },
				non_gtk: { label: "Non-GTK", name: "presensi-non-gtk" },
				siswa: { label: "Siswa", name: "presensi-siswa" },
			},
			loading: true,
			activeTab: "",
			isEditing: false,
			listMesin: [],
		};
	},
	computed: {
		isPetugasPresensi() {
			const roles = this.$store.getters.getRoles;
			return roles?.some((r) => ["dev", "presensi"].includes(r.role));
		},
		routeName() {
			return this.$route.name;
		},
	},
	watch: {
		routeName: {
			immediate: true,
			handler(val) {
				if (val !== "presensi") this.loading = false;

				this.activeTab = val;
			},
		},
	},
	mounted() {
		this.$ws.main.on("log:inserted", this.insertedLog);
		this.$ws.main.on("mesin:inserted", this.insertedMesinPresensi);
		this.$ws.main.on("mesin:updated", this.updatedMesinPresensi);
		this.$ws.main.on("mesin:deleted", this.deletedMesinPresensi);
		this.getJumlahRiwayatPresensi();
		this.getListMesin();
	},
	beforeUnmount() {
		this.$ws.main.off("log:inserted");
		this.$ws.main.off("mesin:inserted");
		this.$ws.main.off("mesin:updated");
		this.$ws.main.off("mesin:deleted");
	},
	methods: {
		insertedLog(data) {
			const d = JSON.parse(data);

			const idx = this.riwayatPresensi.findIndex((rp) => rp.type === d.type);

			if (idx !== -1) {
				this.riwayatPresensi[idx] = {
					...this.riwayatPresensi[idx],
					jumlah: this.riwayatPresensi[idx].jumlah + 1,
				};
				return;
			}
		},
		insertedMesinPresensi(data) {
			const d = JSON.parse(data);

			this.listMesin.push({
				...d,
				_key: `${d.mesin_presensi_id}_${d.cloud_id}_${d.nomor_seri}`,
			});
		},
		updatedMesinPresensi(data) {
			const d = JSON.parse(data);

			const oldData = this.listMesin.find((r) => Number(r.mesin_presensi_id) === Number(d.old_mesin_presensi_id));
			if (oldData) {
				if (d.mesin_presensi_id) oldData.mesin_presensi_id = d.mesin_presensi_id;
				if (d.nama) oldData.nama = d.nama;
				if (d.keterangan) oldData.keterangan = d.keterangan;
			}
		},
		deletedMesinPresensi(data) {
			const d = JSON.parse(data);

			const oldIndex = this.listMesin.findIndex((r) => Number(r.mesin_presensi_id) === Number(d.mesin_presensi_id));

			if (oldIndex !== -1) this.listMesin.splice(oldIndex, 1);
		},
		handleTabChange(val) {
			this.$router.push({ name: val });
		},
		async getJumlahRiwayatPresensi() {
			try {
				const { data } = await this.$defaultApi.post("/log/count/user-type");

				await new Promise((resolve) => setTimeout(resolve, 500));
				this.riwayatPresensi = data.log_counts;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			} finally {
				this.loading = false;
			}
		},
		async getListMesin() {
			try {
				const { data } = await this.$defaultApi.post("/mesin/list");

				this.listMesin = data.list_mesin.map((m) => ({
					...m,
					_key: `${m.mesin_presensi_id}_${m.cloud_id}_${m.nomor_seri}`,
				}));
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			}
		},
	},
};
</script>

<style scoped></style>
